import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FastBackwardOutlinedSvg from "@ant-design/icons-svg/es/asn/FastBackwardOutlined";
import AntdIcon from '../components/AntdIcon';
var FastBackwardOutlined = function FastBackwardOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: FastBackwardOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(FastBackwardOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'FastBackwardOutlined';
}
export default RefIcon;